/*
 * @Author: along longwang6@163.com
 * @Date: 2025-10-08 00:20:44
 * @LastEditors: along longwang6@163.com
 * @LastEditTime: 2025-11-27 15:57:35
 * @FilePath: /ehr-web/src/constants/dingtalk.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 测试环境配置
// REACT_APP_DINGTALK_CORPID_MAP={"649eaa55ea85906c6554fca2":"ding635b9ed6081f61c535c2f4657eb6378f","6503043c162c830ae25f0ae5":"ding409676dba3949eabf2c783f7214b6d69"}
// REACT_APP_DINGTALK_APPID_MAP={"649eaa55ea85906c6554fca2":"dingly7gz4avnxyipbcb","6503043c162c830ae25f0ae5":"dingps4w75bnp21inh3k"}

// 钉钉企业ID映射配置
const CORP_ID_MAP: Record<string, string> = {
  // 示例配置，请根据实际情况修改
  // 测试环境
  '649eaa55ea85906c6554fca2': 'ding635b9ed6081f61c535c2f4657eb6378f',
  '6503043c162c830ae25f0ae5': 'ding409676dba3949eabf2c783f7214b6d69',
  // 百川
  '65968173a139e25966263e53': 'ding15659d06ffb8b325a39a90f97fcb1e09',
  // 四川戎迅数字科技有限公司
  m5jsr8l2posfjzph93b1l6i9: 'ding2e757f979fbb074d4ac5d6980864d335',
  //湖南百川智媒科技有限公司
  '8utntxr1qz78mtu1wa0b94ae': 'dingcf7c685ee498b4cfbc961a6cb783455b',
  //山西智界科技有限公司
  '85cdxzx8htlppeanpcu947dv': 'ding6f9b6377cf1de12dacaaa37764f94726',
  //广州宝宝珠信息科技有限公司
  '4h6ki5q764kgbmw5x7vcwlwf': 'dingdc64da9157711f12f2c783f7214b6d69',
  //广州市哈泽科技有限公司
  '9hc4eeldlh1lwlxm23cy9sl0': 'dingbf6682be483be9d4ee0f45d8e4f7c288',
  //成都音遇星河科技有限公司
  efz1qhnoq8vt5b2emlzo5e88: 'ding03936d9c6204bf91f596950de44b4fd4',
};

// 钉钉应用ID映射配置
const APP_ID_MAP: Record<string, string> = {
  // 示例配置，请根据实际情况修改
  // 测试环境
  '649eaa55ea85906c6554fca2': 'dingly7gz4avnxyipbcb',
  '6503043c162c830ae25f0ae5': 'dingps4w75bnp21inh3k',

  // 百川
  '65968173a139e25966263e53': 'dingivectscu7ckb3iwz',
  // 四川戎迅数字科技有限公司
  m5jsr8l2posfjzph93b1l6i9: 'ding8pyyf49mmwvqc4bu',
  //湖南百川智媒科技有限公司
  '8utntxr1qz78mtu1wa0b94ae': 'ding9qacp3xuwv6fmfy9',
  //山西智界科技有限公司
  '85cdxzx8htlppeanpcu947dv': 'ding2b6rzmkirrsgzgbt',
  //广州宝宝珠信息科技有限公司
  '4h6ki5q764kgbmw5x7vcwlwf': 'dingxugb9a6abwdrbcyf',
  //广州市哈泽科技有限公司
  '9hc4eeldlh1lwlxm23cy9sl0': 'ding2ziealy6phdrkvwp',
  //成都音遇星河科技有限公司
  efz1qhnoq8vt5b2emlzo5e88: 'dingdfmgr0twoh5vx9gf',
};

// 钉钉配置
export const DINGTALK_CONFIG = {
  // 企业ID映射
  CORP_ID_MAP,

  // 应用ID映射
  APP_ID_MAP,

  // 获取企业ID
  getCorpId: (orgId: string) => {
    return DINGTALK_CONFIG.CORP_ID_MAP?.[orgId];
  },

  // 获取应用ID
  getAppId: (orgId: string) => {
    return DINGTALK_CONFIG.APP_ID_MAP?.[orgId];
  },

  // 验证配置是否完整
  validateConfig: (orgId: string) => {
    const corpId = DINGTALK_CONFIG.getCorpId(orgId);
    const appId = DINGTALK_CONFIG.getAppId(orgId);

    return {
      isValid: !!(corpId && appId),
      corpId,
      appId,
      missing: {
        corpId: !corpId,
        appId: !appId,
      },
    };
  },
};
